import { useEffect, useRef, useState } from "react";

/**
 * Returns `value` once it has stopped changing (by content, not identity) for
 * `delayMs`. Callers may pass a freshly built object every render.
 */
export const useDebouncedValue = <T>(value: T, delayMs: number): T => {
    const [debouncedValue, setDebouncedValue] = useState(value);
    const latestValueRef = useRef(value);
    latestValueRef.current = value;
    const contentKey = JSON.stringify(value);

    useEffect(() => {
        const timeoutId = setTimeout(
            () => setDebouncedValue(latestValueRef.current),
            delayMs,
        );
        return () => clearTimeout(timeoutId);
    }, [contentKey, delayMs]);

    return debouncedValue;
};
